module.exports = __webpack_public_path__ + "media/images/logo-3c76488d.png";